import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editFindingCommentDialog from '../dialog.editFindingCommentDialog';
import controller from './finding-comment.controller';
import directive from './finding-comment.directive';


export default angular.module('app.components.advisory.auditTrail.findingComment', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  editFindingCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amFindingComment', directive)
  .controller('FindingCommentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.findingComment created');
